import { useEffect } from "react";
import { Backdrop, Box } from "@mui/material";
import ReactLoading from "react-loading";
import { useAppSelector } from "../../hooks/useAppSelector";
import styles from "./loader.styles";

const Loader = ({ open }: { open?: boolean }) => {
  const { loading } = useAppSelector((state) => state.globalcontent);
  const isLoading = open ?? loading;
  useEffect(() => {
    if (isLoading) {
      document.body.classList.add("bodyOverflowHidden");
    }
    return () => {
      document.body.classList.remove("bodyOverflowHidden");
    };
  }, [isLoading]);

  return (
    <Backdrop sx={styles.loaderContainer} open={isLoading}>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <ReactLoading type="bars" color="white" height={100} width={50} />
      </Box>
    </Backdrop>
  );
};

export default Loader;
